// i18n keys of the multi-tenant work package "cpacklegal" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
// {{label}} is the tax number's statutory name from the country pack — printed as-is (Thai stays Thai) in every language.
export const en: Record<string, string> = {
  cpl_rules: 'Country rules',
  cpl_taxid: 'tax ID check ({{label}}, {{digits}} digits)',
  cpl_forms: 'local legal forms',
  cpl_titles: 'local titles',
  cpl_words: 'amount in words',
  cpl_vat: 'VAT {{rate}}%',
  cpl_none: 'No country rules for {{name}} yet — tax IDs are only checked for being filled in; no local titles, legal forms or amount in words.',
};
export const zh: Record<string, string> = {
  cpl_rules: '国家规则',
  cpl_taxid: '税号校验({{label}},{{digits}} 位)',
  cpl_forms: '本地法人形式',
  cpl_titles: '本地称谓',
  cpl_words: '金额大写',
  cpl_vat: '增值税 {{rate}}%',
  cpl_none: '{{name}} 暂无国家规则 —— 税号只检查是否填写;没有本地称谓、法人形式和金额大写。',
};
export const th: Record<string, string> = {
  cpl_rules: 'กฎของประเทศ',
  cpl_taxid: 'ตรวจเลขผู้เสียภาษี ({{label}}, {{digits}} หลัก)',
  cpl_forms: 'รูปแบบนิติบุคคลท้องถิ่น',
  cpl_titles: 'คำนำหน้าชื่อท้องถิ่น',
  cpl_words: 'จำนวนเงินเป็นตัวอักษร',
  cpl_vat: 'VAT {{rate}}%',
  cpl_none: 'ยังไม่มีกฎของประเทศสำหรับ {{name}} — ตรวจเลขผู้เสียภาษีเพียงว่ากรอกแล้วหรือไม่ ไม่มีคำนำหน้าชื่อ รูปแบบนิติบุคคล หรือจำนวนเงินเป็นตัวอักษรของท้องถิ่น',
};
